import languageActionTypes from '../types/languageActionTypes';

const initialState = {
    language: 'HE',
    screenDirection: 'rtl',
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: null
};

const languageReducer = (state = initialState, action) => {
    switch (action.type) {
        case languageActionTypes.GET_CURRENT_LANGUAGE:
            return {
                ...state,
                language: action.payload,
                screenDirection: action.payload === 'HE' ? 'rtl' : 'ltr'
            }
        case languageActionTypes.SET_CURRENT_LANGUAGE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSuccess: true,
                isError: false,
                language: action.payload,
                screenDirection: action.payload === 'HE' ? 'rtl' : 'ltr'
            }
        case languageActionTypes.SET_CURRENT_LANGUAGE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isSuccess: false,
                isError: true,
                language: 'HE',
                screenDirection: 'rtl'
            };
        default:
            return state;
    }
}

export default languageReducer;